<template>
  <form @submit.prevent="handleSubmit(item)">
    <div class="form-group">
      <label
        for="application_applicationType"
        class="form-control-label">{{ $t('views.application.form.applicationType') }}</label>
      <el-select
        id="application_applicationType"
        :class="['select-default']"
        placeholder=""
        filterable
        v-model="item.applicationType">
        <el-option v-for="option in applicationTypes"
                   class="select-default"
                   :value="option['@id']"
                   :label="option['title']"
                   :key="option['@id']">
        </el-option>
      </el-select>
    </div>
    <b-row>
      <b-col class="form-group">
        <label
          for="internalannouncement_title"
          class="form-control-label">{{ $t('views.internalannouncement.form.title') }}</label>
        <input
          id="internalannouncement_title"
          v-model="item.title"
          placeholder=""
          :class="['form-control', isInvalid('title') ? 'is-invalid' : '']"
          @input="handleUpdateField('title', $event.target.value)"
        />
      </b-col>
      <b-col class="form-group">
        <label
          for="internalannouncement_internalDescription"
          class="form-control-label">{{ $t('views.internalannouncement.form.internalDescription') }}</label>
        <input
          id="internalannouncement_internalDescription"
          v-model="item.internalDescription"
          placeholder=""
          :class="['form-control', isInvalid('internalDescription') ? 'is-invalid' : '']"
          @input="handleUpdateField('internalDescription', $event.target.value)"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col class="form-group">
        <label class="form-control-label">{{$t('views.internalannouncement.form.dateFrom')}}:</label><br>
        <el-date-picker
          :picker-options="{firstDayOfWeek: 1}"
          v-model="item.dateFrom"
          value-format="yyyy-MM-dd HH:mm"
          format="yyyy-MM-dd HH:mm"
          type="datetime"
          default-time="12:00:00">
        </el-date-picker>
      </b-col>
      <b-col class="form-group">
        <label class="form-control-label">{{$t('views.internalannouncement.form.dateTo')}}:</label><br>
        <el-date-picker
          :picker-options="{firstDayOfWeek: 1}"
          v-model="item.dateTo"
          value-format="yyyy-MM-dd HH:mm"
          format="yyyy-MM-dd HH:mm"
          type="datetime"
          default-time="12:00:00">
        </el-date-picker>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="form-group">
          <label for="content">{{ $t('views.internalannouncement.form.content') }}:</label>
          <textarea
            rows="30"
            spellcheck="false"
            style="font-family: 'Consolas'; max-height: 350px;"
            v-model="item.content"
            class="form-control"
            id="htmlContent"
          ></textarea>
          <div v-if="isInvalid('content')" class="text-danger">
            {{ violations.content }}
          </div>
        </div>
      </b-col>
      <b-col>
        <internal-announcement-content :key="item.content" :content="item.content"></internal-announcement-content>
      </b-col>
    </b-row>
    <div class="form-group">
      <label>{{$t("views.internalannouncement.form.recipientType")}}:</label>
      <b-form-group>
        <b-form-checkbox-group v-model="item.recipientType" class="" id="recipientType">
          <b-form-checkbox value="ROLE_CHILD">{{$t("views.internalannouncement.form.recipientTypeOptions.ROLE_CHILD")}}</b-form-checkbox>
          <b-form-checkbox value="ROLE_PARENT">{{$t("views.internalannouncement.form.recipientTypeOptions.ROLE_PARENT")}}</b-form-checkbox>
          <b-form-checkbox value="ROLE_TEACHER">{{$t("views.internalannouncement.form.recipientTypeOptions.ROLE_TEACHER")}}</b-form-checkbox>
          <b-form-checkbox value="ROLE_OFFICE">{{$t("views.internalannouncement.form.recipientTypeOptions.ROLE_OFFICE")}}</b-form-checkbox>
          <b-form-checkbox value="ROLE_ADMIN">{{$t("views.internalannouncement.form.recipientTypeOptions.ROLE_ADMIN")}}</b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
    </div>
    <div class="form-group">
      <label>{{$t("views.internalannouncement.form.priority")}}:</label>
      <b-form-group>
        <b-form-radio-group v-model="item.priority" class="" id="priority">
          <b-form-radio :value="0">{{$t("views.internalannouncement.form.priorityOptions.LOW")}}</b-form-radio>
          <b-form-radio :value="1">{{$t("views.internalannouncement.form.priorityOptions.HIGH")}}</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
    </div>
    <div v-if="item['@id']">
      <b-row>
        <b-col>
          <table class="table table-striped table-hover mt-4">
            <thead>
            <tr>
              <th>{{$t('views.application.show.application')}}</th>
              <th>{{$t('views.application.show.executeReturn')}}</th>
              <th>{{$t('views.application.show.executedAt')}}</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(i, itemIndex) in item.internalAnnouncementApplication" :key="i['@id']">
              <td>
                <p>{{i.application.subdomain}}</p>
              </td>
              <td>
                <p>{{ i.executeReturn }}</p>
              </td>
              <td>
                <p>{{$moment(i.updatedAt).format('YYYY-MM-DD HH:mm')}}</p>
              </td>
              <td>
                <b-btn class="btn btn-danger mt-2" size="sm" @click="removeApplication(i, itemIndex)">
                  <span>{{ $t('buttons.delete') }}</span>
                </b-btn>
              </td>
            </tr>
            </tbody>
          </table>
        </b-col>
        <b-col cols="12">
          <b-btn variant="success" @click="showCreateApplicationModal()">{{ $t('menu.application.create') }}</b-btn>
        </b-col>
      </b-row>
      <b-modal v-model="createApplicationModalVisible" size="m" hide-footer>
        <b-row slot="modal-header">
          <b-col>
            <h6>{{ $t('menu.application.create') }}</h6>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>{{ $t('views.internalannouncement.form.internalAnnouncementApplication') }}:</label>
            <model-select :options="applicationList" v-model="currentApplicationToAdd"></model-select>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <b-btn class="btn btn-success" @click="createNewInternalAnnouncementApplication()">{{ $t('buttons.submit') }}</b-btn>
            <b-btn class="btn btn-danger" @click="hideCreateApplicationModal">{{ $t('buttons.cancel') }}</b-btn>
          </b-col>
        </b-row>
      </b-modal>
    </div>
    <section v-else>
      <Loader v-if="applicationList.length === 0 || loadingApplications"></Loader>
      <div class="form-group">
        <label>{{ $t('views.internalannouncement.form.internalAnnouncementApplication') }} ({{$t('views.exsbsettlements.show.selectedPositionsQuantity')}}): {{internalAnnouncementApplication.length}}</label>
        <multi-select :options="applicationList" :selected-options="internalAnnouncementApplication" @select="selectInternalAnnouncementApplicationHandler"></multi-select>
      </div>
      <b-row>
        <b-col cols="2">
          <label>{{ $t('views.firm.form.tags') }}:</label>
          <model-select :options="tagOptions" v-model="idTag"></model-select>
        </b-col>
        <b-col cols="2">
          <b-button class="mt-4 btn btn-primary" @click="addAllApplicationsFromTag()">{{ $t('views.internalannouncement.form.addAllApplicationsFromTag') }}</b-button>
        </b-col>
        <b-col cols="2">
          <label>{{ $t('views.firm.form.withoutTags') }}:</label>
          <multi-select @select="onSelectWithoutTag" :options="tagOptions" :selected-options="withoutTagsFilter"></multi-select>
        </b-col>
        <b-col cols="2">
          <b-button class="mt-4 btn btn-primary" @click="addAllApplicationsFromWithoutTag()">{{ $t('views.internalannouncement.form.addAllApplicationsFromWithoutTag') }}</b-button>
        </b-col>
        <b-col cols="2">
          <label>{{ $t('views.firm.form.idStatus') }}:</label>
          <model-select :options="statusOptions" v-model="idStatus"></model-select>
        </b-col>
        <b-col cols="2">
          <b-button class="mt-4 btn btn-primary" @click="addAllApplicationsFromStatus()">{{ $t('views.internalannouncement.form.addAllApplicationsFromStatus') }}</b-button>
        </b-col>
        <b-col cols="2">
          <label>{{ $t('views.firm.form.idOpportunity') }}:</label>
          <model-select :options="opportunityOptions" v-model="idOpportunity"></model-select>
        </b-col>
        <b-col cols="2">
          <b-button class="mt-4 btn btn-primary" @click="addAllApplicationsFromSalesOpportunity()">{{ $t('views.internalannouncement.form.addAllApplicationsFromSalesOpportunity') }}</b-button>
        </b-col>
        <b-col cols="2">
          <b-button class="mt-4 btn btn-primary" @click="addAllApplications()">{{ $t('views.internalannouncement.form.addAllApplications') }}</b-button>
        </b-col>
        <b-col cols="2">
          <b-button v-if="internalAnnouncementApplication.length > 0" class="mt-4 btn btn-danger" @click="clearAllApplications()"> {{ $t('views.internalannouncement.form.clearAllApplications') }}</b-button>
        </b-col>
      </b-row>
    </section>
    <div>
      <b-button @click="handleSubmit(item)" variant="success">
        {{ $t('buttons.submit') }}
      </b-button>
      <b-button v-if="!item['@id']" @click="handleSubmit(item, 1)" variant="danger">
        {{ $t('views.internalannouncement.form.storeAndPublish') }}
      </b-button>
    </div>
  </form>
</template>

<script>

import ApiService from '@/utils/ApiService'
import { ModelSelect, MultiSelect } from 'vue-search-select'
import Loader from '@/components/Dashboard/Layout/Loader.vue'
import InternalAnnouncementContent from '@/components/Dashboard/Views/IAMBundle/internalannouncement/internalAnnouncementContent.vue'
import remove from '@/utils/remove'

export default {
  name: 'Form',
  components: {
    InternalAnnouncementContent,
    Loader,
    MultiSelect,
    ModelSelect
  },
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },
    handleUpdateField: {
      type: Function,
      required: true
    },
    values: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      default: () => {}
    },
    initialValues: {
      type: Object,
      default: () => {}
    },
    applicationList: {
      type: Array,
      default: () => []
    },
    tagOptions: {
      type: Array,
      default: () => []
    },
    statusOptions: {
      type: Array,
      default: () => []
    },
    opportunityOptions: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      currentApplicationToAdd: null,
      applicationTypes: [],
      internalAnnouncementApplication: [],
      idTag: null,
      idWithoutTag: [],
      withoutTagsFilter: [],
      idOpportunity: null,
      idStatus: null,
      loadingApplications: false,
      createApplicationModalVisible: false
    }
  },
  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },
    violations () {
      return this.errors || {}
    }
  },
  created () {
    this.getApplicationTypes()
    this.initialInternalAnnouncementApplication()
  },
  methods: {
    async getApplicationTypes () {
      const response = await new ApiService('application_types').getResults()
      this.applicationTypes = response.items
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },
    initialInternalAnnouncementApplication () {
      if (this.item.internalAnnouncementApplication) {
        this.internalAnnouncementApplication = this.item.internalAnnouncementApplication.map(item => {
          return this.applicationList.find(application => application.value === item.application)
        })
      }
    },
    selectInternalAnnouncementApplicationHandler (internalAnnouncementApplication) {
      this.internalAnnouncementApplication = internalAnnouncementApplication
      this.item.internalAnnouncementApplication = internalAnnouncementApplication.map(item => { return { application: item.value } })
    },
    addAllApplications () {
      // Dodaj te aplikacje, których nie ma w this.internalAnnouncementApplication
      const applications = this.applicationList.filter(application => {
        return !this.internalAnnouncementApplication.find(internalAnnouncementApplication => internalAnnouncementApplication.value === application.value)
      })
      this.internalAnnouncementApplication = [...this.internalAnnouncementApplication, ...applications]
      this.item.internalAnnouncementApplication = this.internalAnnouncementApplication.map(item => { return { application: item.value } })
    },
    clearAllApplications () {
      this.internalAnnouncementApplication = []
      this.item.internalAnnouncementApplication = []
    },
    async addAllApplicationsFromTag () {
      let applicationListFromTags = await this.getApplicationList({ 'idUserData.userDataTags.idTag': this.idTag })
      // Dodaj te aplikacje, których nie ma w this.internalAnnouncementApplication
      const applications = applicationListFromTags.filter(application => {
        return !this.internalAnnouncementApplication.find(internalAnnouncementApplication => internalAnnouncementApplication.value === application.value)
      })
      this.internalAnnouncementApplication = [...this.internalAnnouncementApplication, ...applications]
      this.item.internalAnnouncementApplication = this.internalAnnouncementApplication.map(item => { return { application: item.value } })
    },
    async addAllApplicationsFromWithoutTag () {
      let applicationListFromWithoutTags = await this.getApplicationList({ 'applicationUserDataWithoutTag': this.idWithoutTag })
      // Dodaj te aplikacje, których nie ma w this.internalAnnouncementApplication
      const applications = applicationListFromWithoutTags.filter(application => {
        return !this.internalAnnouncementApplication.find(internalAnnouncementApplication => internalAnnouncementApplication.value === application.value)
      })
      this.internalAnnouncementApplication = [...this.internalAnnouncementApplication, ...applications]
      this.item.internalAnnouncementApplication = this.internalAnnouncementApplication.map(item => { return { application: item.value } })
    },
    async addAllApplicationsFromStatus () {
      let applicationListFromStatus = await this.getApplicationList({ 'idUserData.status': this.idStatus })
      // Dodaj te aplikacje, których nie ma w this.internalAnnouncementApplication
      const applications = applicationListFromStatus.filter(application => {
        return !this.internalAnnouncementApplication.find(internalAnnouncementApplication => internalAnnouncementApplication.value === application.value)
      })
      this.internalAnnouncementApplication = [...this.internalAnnouncementApplication, ...applications]
      this.item.internalAnnouncementApplication = this.internalAnnouncementApplication.map(item => { return { application: item.value } })
    },
    async addAllApplicationsFromSalesOpportunity () {
      let applicationListFromSalesOpportunity = await this.getApplicationList({ 'idUserData.salesOpportunity': this.idOpportunity })
      // Dodaj te aplikacje, których nie ma w this.internalAnnouncementApplication
      const applications = applicationListFromSalesOpportunity.filter(application => {
        return !this.internalAnnouncementApplication.find(internalAnnouncementApplication => internalAnnouncementApplication.value === application.value)
      })
      this.internalAnnouncementApplication = [...this.internalAnnouncementApplication, ...applications]
      this.item.internalAnnouncementApplication = this.internalAnnouncementApplication.map(item => { return { application: item.value } })
    },
    async getApplicationList (internalParams = {}) {
      this.loadingApplications = true
      let params = Object.assign({ pagination: false, disableCheckStatus: 1, state: 1 }, internalParams)
      const response = await new ApiService('applications', params).getResults()
      this.loadingApplications = false
      return response.items.map(item => {
        return {
          value: item['@id'],
          text: item.subdomain
        }
      })
    },
    showCreateApplicationModal () {
      this.createApplicationModalVisible = true
    },
    hideCreateApplicationModal () {
      this.createApplicationModalVisible = false
    },
    async createNewInternalAnnouncementApplication () {
      let internalAnnouncementApplication = {
        application: this.currentApplicationToAdd,
        internalAnnouncement: this.item['@id']
      }
      const response = await new ApiService('internal_announcement_applications').post(internalAnnouncementApplication)
      if (response.status === 201) {
        const newApplication = await new ApiService(this.item['@id']).getResults()
        this.item.internalAnnouncementApplication = newApplication.internalAnnouncementApplication
        this.hideCreateApplicationModal()
      }
    },
    removeApplication (item, index) {
      remove(item['@id'], () => {
        this.item.internalAnnouncementApplication.splice(index, 1)
      })
    },
    onSelectWithoutTag (items, lastSelectItem) {
      this.withoutTagsFilter = items
      this.idWithoutTag = items.map(item => {
        return item.value
      })
      this.lastSelectItem = lastSelectItem
    }
  }
}
</script>
